package com.steamstreet.vegasful.browser.account.subscriptions

import com.steamstreet.vegasful.browser.account.Account
import com.steamstreet.vegasful.browser.account.GraphQL
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import com.steamstreet.vegasful.web.ClientController
import com.steamstreet.vegasful.web.EntityViewedController
import kotlinx.coroutines.CoroutineScope
import org.w3c.dom.Element

/**
 * Manages the sending of a VIEWED event to the server for tracking.
 */
class VisitController(val element: Element, private val context: CoroutineScope) : ClientController {
    override suspend fun run() {
        // do nothing if the user isn't logged in.
        if (!Account.isLoggedIn()) return

        element.getAttribute(EntityViewedController.pathAttribute)?.let { path ->
            GraphQL.mutation {
                subscriptions {
                    this.interact(InteractInput(type = InteractionType.VIEWED, path))
                }
            }
        }
    }
}
